<template>
  <v-app>
    <v-content>
      <v-container fluid>

        <h1 class="display-1 my-12" align="center">Пресса о нас</h1>
          <!-- <v-row
            align="center"
            justify="center"
          >
            <v-col cols="12" sm="10" md="8" lg="5">
              <v-select
                v-model="selectedMagazine"
                :items="getMagazinesNames"
                clearable
                label="О нас пишут"
                chips
                hint="Выбор журнала"
                persistent-hint
              ></v-select>
            </v-col>
          </v-row> -->
          <v-row
            align="center"
            justify="center"
          >
            <v-col cols="12" sm="10" md="8" lg="5" >
                <v-sheet>
                  <v-slide-group
                    v-model="selectedMagazine"
                    show-arrows
                    center-active
                  >
                    <v-slide-item
                      v-for="name in getMagazinesNames"
                      :key="name"
                      v-slot:default="{ active, toggle }"
                      :value="name"
                    >
                      <v-btn
                        class="mx-2"
                        :input-value="active"
                        active-class="black white--text"
                        depressed
                        tile
                        large
                        @click="toggle"
                        v-text="name"
                      >
                        <!-- <v-icon
                          v-if="!active"
                          color="white"
                          size="48"
                          v-text="'mdi-close-circle-outline'"
                        ></v-icon> -->
                      </v-btn>
                    </v-slide-item>
                  </v-slide-group>

                  <!-- <v-chip-group
                    v-model="selectedMagazine"
                    center-active
                    active-class="primary--text"
                  >
                    <v-chip
                      v-for="name in getMagazinesNames"
                      :key="name"
                      :value="name"
                      filter
                    >
                      {{ name }}
                    </v-chip>
                  </v-chip-group> -->
                </v-sheet>
            </v-col>
          </v-row>
        <v-row
          align="center"
          justify="center"
          v-for="post in filteredByMagazine"
          :key="post.id"
          class="my-8"
        >
          <v-col cols="12" sm="10" md="8" lg="5">

            <v-card tile flat>

              <v-card-title
                class="headline"
                v-text="post.title"
              >
              </v-card-title>

              <v-card-subtitle class="my-1" v-text="post.date"></v-card-subtitle>

              <v-card-text
                class="text-justify my-1"
                v-if="post.text"
                v-text="post.text"
              >
              </v-card-text>

              <!-- <v-divider></v-divider> -->

              <v-card-actions>
                <v-btn
                  color="grey darken-4"
                  tile
                  text
                  :href="post.link"
                  target="_blank">
                  <v-icon left>mdi-open-in-new</v-icon>
                  Источник
                </v-btn>
                <v-spacer></v-spacer>
                  <v-img
                    class="mr-lg-1"
                    max-width="125"
                    contain
                    alt="post.magazineName"
                    :src="'https://fetichebrand.ru' + post.magazineLogo"
                  >
                  </v-img>
              </v-card-actions>

            </v-card>

          </v-col>
        </v-row>

        <v-row v-if="pageCount > 1">
          <v-col>
            <v-pagination
              color="grey darken-4"
              light
              v-model="page"
              :length="pageCount"
              :total-visible="7"
              :value="pageChangeHandler"
            ></v-pagination>
          </v-col>
        </v-row>

      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import paginationMixin from '@/mixins/pagination.mixin';

export default {
  name: 'Press',
  mixins: [paginationMixin],
  data: () => ({
    selectedMagazine: '',
    posts: [],
    showFullText: false,
  }),
  async mounted() {
    const res = await fetch('https://fetichebrand.ru/!api/getPress.php'); // ?limit=1
    const posts = await res.json();
    this.posts = posts;
  },
  computed: {
    getMagazinesNames() {
      return Array.from(new Set(this.posts.map((post) => post.magazineName)));
    },
    // getMagazinesLogos() {
    //   return Array.from(new Set(this.posts.map((post) => post.magazineLogo)));
    // },
    filteredByMagazine() {
      if (this.selectedMagazine) {
        const filteredPosts = this.posts
          .filter((post) => post.magazineName === this.selectedMagazine);
        this.setupPaginations(filteredPosts);
        return this.items;
      }
      this.setupPaginations(this.posts);
      return this.items;
    },
  },
};
</script>

<style>
.v-card__title {
  word-break: break-word !important;
}
</style>
